import React, { PureComponent, Suspense } from 'react';
import { Button } from '@jg/react-tracking';
import Loading from '@jg/loading';
import ImageEditor, { OnEditChange } from '@jg/image-editor';
import camera from '@jg/icons/lib/camera.svg';
import addImage from '@jg/icons/lib/add-image.svg';
import { Trans, withTranslation } from 'react-i18next';
import isMobile from '../../utils/isMobile';
import { TStoryForm } from './StoryForm.d';
import { makePhotoUrl, withTrack } from '../../utils';
import FormError from '../FormError/FormError';

const RichEditorWrapper = React.lazy(() => import('../Form/RichEditorWrapper'));

export class StoryForm extends PureComponent<TStoryForm> {
  onImageEditorChange = (imageData: OnEditChange) => {
    const { setFieldValue, track } = this.props;
    setFieldValue('heroImage', imageData.base64 || '');
    track({
      action_name: 'link click',
      subtype: 'hyperlink',
      event: 'link click',
      event_value: 'upload a team cover photo',
      page_section: 'page creation > whats the story',
    });
  };

  render() {
    const {
      values: { heroImage, story },
      errors,
      touched,
      handleSubmit,
      isInFlight,
      t,
      id,
    } = this.props;

    const uploadIcon = isMobile(window) ? camera : addImage;
    const imageEditorMode = heroImage ? 'preview' : 'pick';
    return (
      <form
        onSubmit={handleSubmit}
        className="jg-space-mtmd"
        data-qa="form-whats-the-story"
      >
        <div className="jg-input-wrapper jg-space-mbmd" data-qa="imageEditor">
          <ImageEditor
            mode={imageEditorMode}
            image={heroImage ? makePhotoUrl(heroImage) : ''}
            editData={{ outputWidth: 1024, outputHeight: 576 }}
            showUploadButton
            onEditChange={this.onImageEditorChange}
            uploadButtonClass="jg-tc--upload-button jg-space-mtsm"
            uploadButtonLabel={t('content.story.heroImage.uploadbutton')}
            imageType="image/png, image/jpeg"
            uploadIcon={uploadIcon}
            sliderId="range-slider"
          />
          {touched.heroImage &&
            errors.heroImage && <FormError message={errors.heroImage} />}
        </div>
        <div className="jg-input-wrapper jg-space-mbmd">
          <label
            className="jg-h3 jg-display-b jg-space-mbxs"
            htmlFor="jg-tc-create-team-input"
          >
            <Trans i18nKey="content.story.description.title" />
          </label>
          <Suspense
            fallback={<div className="richeditor--loading">Loading...</div>}
          >
            <RichEditorWrapper
              id={id}
              {...this.props}
              placeholder={t('content.story.description.placeholder')}
              storyValue={story}
              incompatibleRichContentMessage={t(
                'content.story.incompatiblerichcontent',
              )}
            />
          </Suspense>
          {touched.story &&
            errors.story && (
              <div className="jg-form-error-copy" role="alert">
                {errors.story}
              </div>
            )}
        </div>
        <div className="jg-tc-button-container">
          <Button
            disabled={isInFlight}
            type="submit"
            className="jg-btn jg-space-mbmd"
            data-qa="story-form-continue-button"
            trackingData={{
              action_name: 'link click',
              subtype: 'button',
              event: 'link click',
              event_value: 'continue',
              page_section: 'page creation > whats the story',
            }}
          >
            {isInFlight ? (
              <Loading size="small" colour="purple" />
            ) : (
              <Trans i18nKey="global.button.continue" />
            )}
          </Button>
        </div>
      </form>
    );
  }
}

export default withTranslation()(withTrack(StoryForm));
